// This component will overwrite a string in case there is found a phone number or an email address.
export function parseMessageProtocols(text) {
  const emailRegex =
    /mailto:([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
  const telRegex = /tel:(\+?[\d\s]{3,})/g;
  const formatText = (text: string) =>
    text
      .replace(telRegex, `<a href="tel:$1">$1</a>`)
      .replace(emailRegex, `<a href="mailto:$1">$1</a>`);

  return formatText(text);
}
